var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box",class:_vm.getBackgroundClass},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-2 d-print-none"},[_c('div',{staticClass:"info-box__icon"},[(_vm.type === 'warning')?_c('iconWarning',{staticClass:"icon"}):_vm._e()],1)]),_c('div',{staticClass:"col-12 col-md-10"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }